import { navigateToUrl } from 'src/lib/browser';
import { openPopup, subscribeToMessages } from 'src/lib/popup';

interface AuthData {
  errorMessage?: string;
  [key: string]: unknown;
}

export const OAUTH_POPUP_NAME = 'oauth-popup';

const POPUP_OPTIONS = {
  name: OAUTH_POPUP_NAME,
  width: 600,
  height: 800,
};

export const openOAuthPopup = (authUrl: string, popupOptions = {}) =>
  new Promise((resolve, reject) => {
    // The listener reads `popup`, so open it first.
    const popup = openPopup(authUrl, { ...POPUP_OPTIONS, ...popupOptions });

    // The browser, or a window that an AI tool opened, can block pop-ups.
    // The sign-in then continues in this window. The promise stays pending while the page unloads.
    if (!popup) {
      navigateToUrl(authUrl);
      return;
    }

    const resultHandler = (authData?: AuthData) => {
      popup.close();

      if (!authData) {
        reject();
        return;
      }

      if (authData.errorMessage) {
        reject(new Error(authData.errorMessage));
        return;
      }

      resolve(authData);
    };

    // Listen for message from popup
    const unsubscribeFromMessages = subscribeToMessages(
      (data: AuthData) => {
        unsubscribeFromMessages();
        resultHandler(data);
      },
      { ...POPUP_OPTIONS, ...popupOptions }
    );

    popup.focus();

    // Run a timer, to check if popup was closed by user, and hasn't sent a message
    const timer = setInterval(() => {
      if (!popup.closed) {
        return;
      }

      clearInterval(timer);
      unsubscribeFromMessages();
      resultHandler();
    }, 100);
  });
